import React from "react";
import classNames from "classnames";
export type BoxProps = {
  children: React.ReactNode;
  className?: string;
};

export const Box = ({ children, className = "" }: BoxProps) => {
  const internalClassName = classNames("gpc__box", className);

  return <div className={internalClassName}>{children}</div>;
};

export default Box;
